import React, { useEffect } from 'react';
import { benefits } from '../Data/benefits';
import '../styles/WhyJoinUs.css';

const WhyJoinUs = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          if (entry.target.classList.contains('section-title')) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
          if (entry.target.classList.contains('benefit-card')) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.section-title, .benefit-card').forEach(el => {
      observer.observe(el);
      
      if (el.classList.contains('benefit-card')) {
        const index = Array.from(document.querySelectorAll('.benefit-card')).indexOf(el);
        el.style.transitionDelay = `${index * 0.1}s`;
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="why-join" id="why-join">
      <div className="section-container">
        <div className="section-title">
          <h2>Why Join Dr. BhuPat Pharma?</h2>
          <p>We foster a culture of innovation, collaboration, and growth where your work makes a real difference.</p>
        </div>
        
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <i className={`fas ${benefit.icon} benefit-icon floating`} style={{ animationDelay: `${index * 0.2}s` }}></i>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyJoinUs;